import React, { useState } from 'react'
import { ClickOutside } from '@truphone/utils'
import { Arrow, ArrowLinkOutSideBox } from '@truphone/icons'

export default function OptionsSelection(props) {
  const [open, setOpen] = useState(true)
  const [inlineSelected, setInlineSelected] = useState(null)
  const inline = props.style === 'inline'

  const [selected, setSelected] = useState(null)

  const [remainingOption, setRemainingOptions] = useState(
    props.value ? props.options.filter((item) => item.value !== props.value) : props.options
  )

  const optionSelect = (option) => {
    if (option.href) {
      if (option.openTab) {
        window.open(option.href, '_blank')
      } else {
        window.location = option.href
      }
    } else if (props.onChange) {
      props.onChange(option.value)
    }
    if (!inline) {
      setSelected(props.options.find((item) => item.value === option.value))
      setRemainingOptions(props.options.filter((item) => item.value !== option.value))
      setOpen(false)
    } else {
      setInlineSelected(option.value)
    }
  }

  return (
    <ClickOutside
      onClickOutside={() => {
        if (props.value && props.style !== 'inline') {
          setOpen(false)
        }
      }}
    >
      <div className="inline-block">
        <div className={`flex ${inline ? 'flex-row' : 'flex-col items-start'}`}>
          {selected && (
            <div className="flex">
              <button
                className={`bg-black text-white flex items-center border-2 border-black rounded px-6 py-2 mr-4 mb-2`}
                data-value={selected.value || selected.text}
              >
                {selected.text}
                {selected.href && (
                  <span className="ml-2">
                    {!selected.openTab ? (
                      <Arrow className="w-4 h-4 -rotate-90" />
                    ) : (
                      <ArrowLinkOutSideBox />
                    )}
                  </span>
                )}
              </button>
              {selected && !inline && (
                <div
                  className="relative w-10 h-10 flex justify-center items-center cursor-pointer"
                  onClick={() => setOpen(!open)}
                >
                  <div
                    className={`absolute right-4 h-5 w-0 pointer-events-none ${
                      open ? 'rotate-180 top-1' : 'top-4 '
                    }`}
                    style={{
                      borderStyle: 'solid',
                      borderWidth: '8px 5.5px 0 5.5px',
                      borderColor: '#000000 transparent transparent transparent'
                    }}
                  ></div>
                </div>
              )}
            </div>
          )}
          {remainingOption &&
            remainingOption.map((option, j) => {
              return (
                <button
                  key={`option-selection-${j}`}
                  className={`items-center text-black border-2 border-black rounded px-6 py-2 mr-4 mb-2 hover:bg-black hover:bg-opacity-10 active:opacity-30 active:bg-black active:text-white ${
                    inline ? '' : 'animate__fadeInUp'
                  } ${inlineSelected === option.value ? 'bg-black text-white' : ''} ${
                    open ? 'flex' : inline ? 'flex' : 'hidden'
                  }`}
                  data-href={option.href}
                  data-value={option.value || option.text}
                  onClick={() => optionSelect(option)}
                  style={{ animationDelay: 0.15 * j + 's' }}
                >
                  {option.text}
                  {option.href && (
                    <span className="ml-2">
                      {!option.openTab ? (
                        <Arrow className="w-4 h-4 -rotate-90" />
                      ) : (
                        <ArrowLinkOutSideBox />
                      )}
                    </span>
                  )}
                </button>
              )
            })}
        </div>
      </div>
    </ClickOutside>
  )
}
